import { useState, useEffect, useRef, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, Offcanvas, Badge, NavDropdown } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import logo from "./../../assets/new_logo.png";
import { IoIosSearch } from "react-icons/io";
import { PiBookOpenText } from "react-icons/pi";
import { useCategorySubCategoryData } from "../../http/apiService";
import { QueryCache } from "react-query";
import SearchBar from "./SearchBar";
import useCart from "../../hook/useCart";
import { TiShoppingCart } from "react-icons/ti";
import { MapContext } from "../../context/MapContext";
import kuwait from "./../../assets/images/logo/kuwait.png";
import uae from "./../../assets/images/logo/united-arab-emirates.png";
import saudiArabia from "./../../assets/images/logo/saudi-arabia.png";
import { domainsJson } from "../../utils/constants";
import { getLogoWithDomain } from "../../utils/helper";
import MegaMenu from "./MegaMenu";
import "./Navbar.scss";
import TranslateWidget from "../../components/translateWidget";

const MainNavbar = () => {
  const { setMapValue, mapValue } = useContext(MapContext);
  const currentUrl = window.location.href;
  const { pathname } = useLocation();
  const [search, setSearch] = useState(false);
  const searchRef = useRef(null);
  const { getLocalCart, CartLength } = useCart();
  const queryCache = new QueryCache();
  const { data: categorySubCategoryData } = useCategorySubCategoryData(queryCache);
  const categoryData = categorySubCategoryData?.data || [];

  const menuItems =
    categoryData?.map((item, index) => ({
      id: index,
      name: item.name,
      image: item.featured_img,
      link: `/product/${item?.route}`,
      // description: "Premium food packaging solutions",
    })) || [];

  useEffect(() => {
    getLocalCart();
    setSearch(false);
  }, []);

  useEffect(() => {
    setSearch(false);
  }, [pathname]);

  useEffect(() => {
    const currentDomain = Object.keys(domainsJson).find((key) => currentUrl.includes(domainsJson[key]));
    setMapValue(currentDomain ? currentDomain : "kuwait");
  }, [currentUrl, setMapValue]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearch(false);
      } else {
        setSearch(true);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="navbar-wrap sticky-top">
        <Navbar expand="lg">
          <Navbar.Brand className="d-flex align-items-center">
            <div className="d-flex flex-column me-2">
              <a href={domainsJson.kuwait}>
                <img src={kuwait} loading="lazy" alt="Kuwait Flag" className="logo-img" />
              </a>
              <a href={domainsJson.jeddah}>
                <img src={saudiArabia} loading="lazy" alt="Saudi Arabia Flag" className="logo-img" />
              </a>
              <a href={domainsJson.uae}>
                <img src={uae} loading="lazy" alt="UAE Flag" className="logo-img" />
              </a>
            </div>
            <Link to={"/"}>
              <figure style={{ width: "102px" }}>
                <img src={getLogoWithDomain(mapValue)} style={{ width: "83px" }} alt="K-PAK Logo" />
              </figure>
            </Link>
          </Navbar.Brand>

          <div className="d-flex">
            <Navbar className="mbl_view_serach_icons">
              <Nav className="navbar-icons">
                <div ref={searchRef} style={{ position: "relative" }}>
                  <Nav.Link className="searchbar-icon" onClick={() => setSearch((prev) => !prev)}>
                    <IoIosSearch fontSize="24px" />
                  </Nav.Link>
                </div>
                <Nav.Link as={Link} to="/cart" className={`badge_icon_wrape ${pathname === "/cart" && "active"}`}>
                  <TiShoppingCart fontSize="24px" />
                  <Badge className="badge_wrape">{CartLength}</Badge>
                </Nav.Link>
              </Nav>
            </Navbar>

            <Navbar className="mbl_view_icons">
              <Nav className="navbar-icons">
                <Nav.Link as={Link} to="/cart" className={`badge_icon_wrape ${pathname === "/cart" && "active"}`}>
                  <TiShoppingCart fontSize="24px" />
                  <Badge className="badge_wrape">{CartLength}</Badge>
                </Nav.Link>
                <Nav.Link href="http://kuwaitpack.com/catalogue.pdf" target="_blank">
                  <PiBookOpenText fontSize="24px" />
                </Nav.Link>
              </Nav>
            </Navbar>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-sm`} />
          </div>

          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-sm`}
            aria-labelledby={`offcanvasNavbarLabel-expand-sm`}
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-sm`}>
                <figure className="mbl_figure">
                  <img src={getLogoWithDomain(mapValue)} alt="K-PAK Logo" style={{ width: "86px" }} className="image" />
                </figure>
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
              <Nav className="mx-auto items">
                <Nav.Link as={Link} to="/" className={pathname === "/" && "active"}>
                  Home
                </Nav.Link>
                <Nav.Link as={Link} to="/about" className={pathname === "/about" && "active"}>
                  About Us
                </Nav.Link>

                <div className="d-none d-lg-block">
                  <MegaMenu menuItem={menuItems} menuTitle="Products" />
                </div>

                <div className="d-lg-none">
                  <NavDropdown title="Product">
                    {categoryData?.map((item) => (
                      <NavDropdown.Item
                        as={Link}
                        to={`/product/${item?.route}`}
                        key={item?.id}
                        className={`cat-dropdown ${pathname === `/product/${item?.route}` && "active"}`}
                      >
                        {item?.name}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                </div>

                <Nav.Link as={Link} to="/factories" className={pathname === "/factories" && "active"}>
                  Factories
                </Nav.Link>
                <Nav.Link as={Link} to="/career" className={pathname === "/career" && "active"}>
                  Careers
                </Nav.Link>
                <Nav.Link as={Link} to="/events" className={pathname === "/events" && "active"}>
                  Events
                </Nav.Link>
                <Nav.Link as={Link} to="/contact" className={pathname === "/contact" && "active"}>
                  Contact
                </Nav.Link>
              </Nav>

              <Nav className="navbar-icons">
                <div>
                  <div className="mx-3">
                    <TranslateWidget />
                  </div>
                </div>
                <div ref={searchRef}>
                  <SearchBar search={search} setSearch={setSearch} />
                </div>
                <Nav.Link as={Link} to="/cart" className={`badge_icon_wrape ${pathname === "/cart" && "active"}`}>
                  <TiShoppingCart fontSize="24px" />
                  <Badge className="badge_wrape">{CartLength}</Badge>
                </Nav.Link>
                <Nav.Link href="http://kuwaitpack.com/catalogue.pdf" target="_blank">
                  <PiBookOpenText fontSize="24px" />
                </Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Navbar>
      </div>
    </>
  );
};

export default MainNavbar;
